<template lang="pug">
  v-content(:class="$isMobileXSmall ? 'bg-mobile' : 'bg'").white.pa-0.ma-0
    v-container(fluid fill-height).pa-0.ma-0
      v-layout(align-center justify-center).mt-n12
        v-col(
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
        )
          v-card.elevation-12
            v-card-title
              v-row(
                justify="center"
                no-gutters
              )
                v-col(cols="12").text-center
                  img(
                    :src="emblem"
                    height="30px"
                  )
                v-col(cols="12").text-center
                  p.font-16 Welcome to Mighty Minds #[small {{appVersion}}]
            v-card-text
              v-form(
                ref="formRef"
                v-model="valid" 
                lazy-validation
                @keydown.native.enter="valid && validate()"
              )
                v-text-field(
                  v-model="email"
                  label="Email Address" 
                  name="login" 
                  type="email"
                  outlined
                  autofocus
                  :rules="[...requiredRule]"
                  :disabled="loading"
                )
                v-text-field(
                  v-model="password"
                  label="Password"
                  name="password"
                  type="password"
                  outlined
                  :rules="[requiredRule, passwordRule]"
                  :disabled="loading"
                )
            v-card-actions.pa-4
              v-spacer
              v-btn(
                color="primary"
                large
                :loading="loading"
                :disabled="loading"
                @click.stop="validate"
              ) Login
</template>

<script>
import {
  requiredRule,
  passwordRule
} from '../utils/rules';
import emblem from '@/assets/mmi-emblem.png';
import { firebaseAuth } from '../plugins/firebase';

export default {
  data () {
    return {
      valid: false,
      loading: false,
      email: '',
      password: '',
      emblem,
      unsubsribe: function () {}
    };
  },
  computed: {
    appVersion () {
      return this.$store.state.ui.packageVersion;
    }
  },
  created () {
    this.requiredRule = requiredRule;
    this.passwordRule = passwordRule;
    this.init();
  },
  beforeDestroy () {
    this.unsubsribe();
  },
  methods: {
    async init () {
      try {
        this.unsubsribe = firebaseAuth.onAuthStateChanged(async user => {
          if (user) {
            this.$setLoading(true);
            this.$enqueueSnack('Redirecting...');
            const account = await this.$store.dispatch('auth/getAccount', user.uid);
            const org = await this.$store.dispatch('organization/getOrganization', {
              id: account.isAdminOf
            });
            if (org) {
              this.$router.push({ name: 'main', params: { id: org.id } });
            }
          }
        });
      } catch (e) {
        console.error(e);
        this.$enqueueSnack(e);
      } finally {
        this.$setLoading(false);
      }
    },
    validate () {
      const valid = this.$refs.formRef.validate();
      if (valid) {
        this.submit();
      }
    },
    async submit () {
      try {
        this.loading = true;
        await this.$store.dispatch('auth/adminSignIn', {
          email: this.email,
          password: this.password
        });
        this.$enqueueSnack('Login successful');
      } catch (e) {
        console.error(e);
        this.$enqueueSnack(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style>
.bg {
  background-image: url('../assets/mmi-admin-footer.png');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: contain;
}
.bg-mobile {
  background-image: url('../assets/mmi-home-footer-background-mobile.png');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: contain;
}
</style>